export default function MainCoverPage() {
  return (
    <>
      <div className="img-cover">
        <img src="main-photo.jpg" alt="" />
        <div className="contat">
          <h4>نقدم نحن مؤسسة أبو الجدايل</h4>
          <h2>حلول وخدمات التوظيف</h2>
        </div>
        <div className="content" dir="rtl" lang="ar">
          <h1>توفر الشركة خدمات التوظيف فى مجالات متعددة</h1>

          <h3>
            مثل البناء , الفندقة ,الرعاية الصحية ,الاغذية و المشروبات ,
            التكنولوجيا ,و الزراعة لذلك هى الخيار الامثل لشركتك
          </h3>
        </div>
      </div>
    </>
  );
}
